module.exports = __webpack_public_path__ + "img/bgimg.0d65cb24.jpg";